/**
 * @fileoverview Input/output schemas for world-system-snapshotter-v3.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { WorldSystemAttributesV3Schema, WorldSystemSnapshotV3Schema } from '@/domains/world-building/schemas';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  worldSystem: z.object({
    id: z.string(),
    name: z.string(),
    type: z.literal('system'),
    element: z.enum(['magic-system', 'natural-law', 'social-custom', 'technology', 'material']),
    initialDescription: z.string().optional(),
  }).describe('The world system being snapshotted.'),
  previousSnapshot: WorldSystemSnapshotV3Schema.optional().describe('The system state before this chapter.'),
  chapterContent: z.string().describe('The full content of the chapter to analyze.'),
  chapterNumber: z.number().describe('The chapter number for snapshot metadata.'),
});

export type Input = z.infer<typeof InputSchema>;

export const OutputSchema = WorldSystemAttributesV3Schema.extend({
  notPresentInChapter: z.boolean().optional().describe('True if the system was not mentioned or relevant in this chapter.'),
});

export type Output = z.infer<typeof OutputSchema>;
